var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"ui mini divided list"},_vm._l((_vm.Rules),function(rule,idx){return _c('li',{key:idx},[_vm._v("\n        "+_vm._s(rule)+"\n    ")])}))}
var staticRenderFns = []

export { render, staticRenderFns }